export default {
  name: 'MultiSelector',
  props: {
    items: Array,
    selectedItems: Array,
    placeholder: String
  },
  data() {
    return {
      selectedItem: []
    }
  },
  beforeMount() {
    this.selectedItem = this.selectedItems.filter(item =>
      this.filteredItems.some(filtered => filtered.attributeGroupUuid === item)
    )
  },
  computed: {
    selectAll() {
      return this.selectedItem.length && this.selectedItem.length === this.filteredItems.length
    },
    selectSome() {
      return this.selectedItem.length > 0 && !this.selectAll
    },
    icon() {
      if (this.selectAll) return 'mdi-close-box'
      if (this.selectSome) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    filteredItems() {
      return this.items.filter(item => item.attributeGroupCode)
    }
  },

  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.selectAll) {
          this.selectedItem = []
        } else {
          this.selectedItem = this.filteredItems
            .slice()
            .map(item => item.attributeGroupUuid)
        }
      })
    }
  },

  watch: {
    selectedItem: {
      handler: function (newVal, oldVal) {
        this.$emit('setSelectItems', {
          new_val: newVal,
          old_val: oldVal
        })
      }
    }
  }
}
